// src/config/api.js
const envBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();
const BASE_URL = envBaseUrl || "http://localhost:5000";

// 🔥 THIS FIXES YOUR ERROR
export const API_BASE_URL = BASE_URL;

// optional helper (you can keep or remove)
export const api = {
  getSettings: async () => {
    const res = await fetch(`${BASE_URL}/api/settings`);
    return res.json();
  },

  updateSettings: async (data) => {
    const res = await fetch(`${BASE_URL}/api/settings`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
    return res.json();
  }
};